<template>
    <div class="addProductos">
        <div class="dvTitle bg-light">
            <h5 class="subtitle" >
                Agregar Producto
            </h5>
        </div>

        <div class="dvContenedor">

            <b-form @submit="save" class="mb-4">
                <div class="form">
                <div class="col-md-12">

                    <div class="form-group">
                        <label>
                            Descripción <b>*</b>
                            <Input required v-model="data.description" :class="data.errorDescripcion ? 'has-error' : ''"
                            @search="validarInput('description','errorDescripcion')"/>
                        </label>
                    </div>

                    <div class="form-group">
                        <label>
                            Precio <b>*</b>
                            <Input required v-model="data.price" :class="data.errorPrice ? 'has-error' : ''"
                                   type="number"
                                   @search="validarInput('price','errorPrice')"/>
                        </label>
                    </div>

                    <div class="form-group">
                        <label class="form-check">
                            <span>IVA</span>
                            <Input v-model="data.tax_included" type="checkbox" />
                        </label>
                    </div>

                    <div class="form-group">
                        <label :class="data.errorProducto ? 'has-error-2' : ''">
                            Clave de producto <b>*</b>
                            <v-select v-model="data.product_key" :options="keyProducto"
                                      :reduce="option => option.clave"
                                      @input="validarInput('product_key','errorProducto')" />
                        </label>
                    </div>


                    <div class="form-group">
                        <label :class="data.errorUnidad ? 'has-error-2' : ''">
                            Clave de unidad de medida
                            <v-select v-model="data.unidad_key" :options="keyUnidad"
                                      :reduce="option => option.clave"
                                      @input="validarInput('unidad_key','errorUnidad')" />
                        </label>
                        <h6 class="position-relative" style="top: -5px;">El valor por default <b>"H87"</b></h6>
                    </div>

                    <div class="form-group">
                        <label>
                            Sku
                            <Input v-model="data.sku" />
                        </label>
                    </div>

                </div>
            </div>

                    <div class="col-md-12 text-left d-flex justify-content-between mt-4">
                        <div class="btn btn-secondary" @click="cancelar">
                            <i class="fas fa-times-circle mr-1"></i>
                            Cancelar
                        </div>
                        <div class="btn btn-danger" @click="guardar" >
                            <i class="far fa-save mr-1"></i>
                            Guardar
                        </div>
                    </div>

                <input type="submit" id="frProducto" class="d-none" v-show="dummy">

            </b-form>
        </div>

    </div>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex';
    import swal from 'sweetalert';
    import Input from "../../components/comun/Input";
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "AddProductos",
        components: {Input},
        computed: {
            ...mapState([
                'refresh'
            ]),
        },
        data() {
            return {
                data: {
                    tax_included: false
                },
                selected: {},
                keyProducto: [],
                keyUnidad: [],
                options: [{code: 'CA', label: 'Canada'}],
                dummy: true
            }
        },

        mounted: function () {
            this.getProductKey().then( data => {
                this.keyProducto = data.keys;
            });

            this.getUnidadKey().then( data => {
                this.keyUnidad = data.keys;
            });
        },

        methods: {

            ...mapMutations([
                'SET_TOTALES'
            ]),

            ...mapActions([
                'postSaveProducto',
                'getTotales',
                'getProductKey',
                'getUnidadKey',
            ]),

            guardar: function () {
                if (this.validar()) {
                    document.getElementById('frProducto').click()
                }
            },

            cancelar: function () {
                this.$router.push('/Productos');
            },

            validarInput: function (input, error) {
                if ( !this.data[input] ) {
                    this.data[error] = true;
                } else {
                    this.data[error] = false;
                }
            },

            validar: function () {
                let isOK = true;

                if ( !this.data.description ) {
                    this.data.errorDescripcion = true;
                    isOK = false;
                } else {
                    this.data.errorDescripcion = false;
                }

                if ( !this.data.price ) {
                    this.data.errorPrice = true;
                    isOK = false;
                } else {
                    this.data.errorPrice = false;
                }

                if ( !this.data.product_key ) {
                    this.data.errorProducto = true;
                    isOK = false;
                } else {
                    this.data.errorProducto = false;
                }

                if ( !this.data.unidad_key ) {
                    this.data.errorUnidad = true;
                    isOK = false;
                } else {
                    this.data.errorUnidad = false;
                }


                this.dummy = !this.dummy;
                return isOK;
            },

            save: function (event) {
                event.preventDefault();
                this.postSaveProducto(this.data).then( data => {
                    swal('Operación exitosa', "Los datos fueron guardados exitosamente",'success' );
                    this.getTotales().then( data => {
                        this.SET_TOTALES(data);
                        this.$router.push('/Productos');
                    });
                }).catch( err => {
                    swal('Error', "No se pudo guardar la información, intentelo más tarde.",'error' );
                });
            }
        }
    }
</script>

<style scoped lang="scss">

    @import "../../style/base";

    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    input[type=number] {
        -moz-appearance: textfield;
        appearance: textfield;
        margin: 0;
    }

    .addProductos {

        border: 1px solid #e6ebf4;
        border-radius: .25rem;
        background-color: #fff;
        margin: 20px;

        animation-name: fade;
        animation-duration: 1.5s;
        animation-timing-function: ease-in-out;

        & .dvTitle {
            @include flexRow;
            justify-content: space-between;
            align-items: center;
            padding: .75rem 1.25rem;
        }

        & .dvContenedor {
            transition: opacity .25s ease-out;
            width: 100%;
            margin: 0 auto;
            padding: 1.25rem 1.25rem 1px;
            overflow-x: visible;

            & div.form {
                width: 100%;
                text-align: left;

                & label {
                    font-size: 1.1rem;
                    font-weight: 600;
                    width: 100%;

                    &.form-check {
                        @include flexRow;
                        align-items: center;
                        padding: 0;

                        & span {
                            order: 2;
                        }

                        & input {
                            width: 25px;
                            order: 1;

                            &.last {
                                order: 3;
                            }
                        }
                    }
                }
            }

        }
    }

</style>